<NBRadioGroup
  v-model="selectedWrappingOption"
  :options="wrappingOptions"
  valueKey="type"
>
  <template #default="{ option }">
    <div class="label">{{ option.description }}</div>
  </template>
</NBRadioGroup>
